import RBModal from "react-bootstrap/Modal";
import styled from "styled-components";

export const Modal = styled(RBModal)`
  .modal-dialog-centered {
    justify-content: center;
  }

  .modal-content {
    width: 600px;
  }

  .modal-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding-top: 27px;
  }

  .title {
    font-size: 1.5rem;
    margin-bottom: 35px;
  }

  .message {
    margin-top: -20px;
  }

  p {
    align-self: center;
    max-width: 380px;
    margin-top: 18px;
    margin-bottom: 35px;
  }

  /* .btn {
    width: 70px;
    margin: 5px;
  } */
`;
